import {
  CREATE_GLOBAL_ITEM_REQUESTED,
  CREATE_GLOBAL_ITEM_SUCCEEDED,
  CREATE_GLOBAL_ITEM_FAILED,
  GET_GLOBAL_ITEM_REQUESTED,
  GET_GLOBAL_ITEM_SUCCEEDED,
  GET_GLOBAL_ITEM_FAILED,
  REMOVE_GLOBAL_ITEM_REQUESTED,
  REMOVE_GLOBAL_ITEM_SUCCEEDED,
  REMOVE_GLOBAL_ITEM_FAILED,
  UPDATE_TOGGLE,
  UPDATE_GLOBAL_ITEM_REQUESTED,
  UPDATE_GLOBAL_ITEM_SUCCEEDED,
  UPDATE_GLOBAL_ITEM_FAILED,
  SEARCH_GLOBAL_ITEM_SUCCEEDED,
  ADD_ITEM_FILTERS_BY_MENU,
  ADD_ITEM_FILTERS_BY_CATEGORY,
  ADD_ITEM_FILTERS_BY_INVENTORY_STATE,
  SET_ITEMS_INDEXES_IN_MODIFIER_GROUPS,
  SET_ITEMS_INDEXES,
  CLEAR_ITEMS_INDEXES,
  GET_FILTERED_AND_PAGINATED_ITEMS_SUCCEEDED,
  GET_FILTERED_AND_PAGINATED_ITEMS_REQUESTED,
  GET_FILTERED_AND_PAGINATED_ITEMS_FAILED,
  SET_ITEMS_OPTIMISTIC_LIST_IMAGE,
} from './constants'
import api from 'utils/api'
import { isEmpty } from 'lodash'

import {
  createPriceLevelRequested,
  createPriceLevelSucceeded,
  loadPriceLevels,
} from 'store/PriceLevels/actions'
import { createItemMapping } from 'store/ItemMappings/actions'

import { calculateItemmMappingsToCreateAndDelete } from 'utils/items'

export const setItemOptimisticListImage = (payload) => ({
  type: SET_ITEMS_OPTIMISTIC_LIST_IMAGE,
  payload,
})

export const setItemsIndexesInModifierGroups = (payload) => ({
  type: SET_ITEMS_INDEXES_IN_MODIFIER_GROUPS,
  payload,
})

export const setItemsIndexes = (payload) => ({
  type: SET_ITEMS_INDEXES,
  payload,
})

export const clearItemsIndexes = () => ({
  type: CLEAR_ITEMS_INDEXES,
})

export const addItemFiltersByInventoryState = (payload) => ({
  type: ADD_ITEM_FILTERS_BY_INVENTORY_STATE,
  payload,
})

export const addItemFiltersByCategory = (payload) => ({
  type: ADD_ITEM_FILTERS_BY_CATEGORY,
  payload,
})

export const addItemFiltersByMenu = (payload) => ({
  type: ADD_ITEM_FILTERS_BY_MENU,
  payload,
})

export const createGlobalItemRequested = () => ({
  type: CREATE_GLOBAL_ITEM_REQUESTED,
})
export const createGlobalItemSucceeded = (payload) => ({
  type: CREATE_GLOBAL_ITEM_SUCCEEDED,
  payload,
})
export const createGlobalItemFailed = () => ({
  type: CREATE_GLOBAL_ITEM_FAILED,
})

export const getGlobalItemsRequested = () => ({
  type: GET_GLOBAL_ITEM_REQUESTED,
})

export const getGlobalItemSucceeded = (payload) => ({
  type: GET_GLOBAL_ITEM_SUCCEEDED,
  payload,
})

export const getGlobalItemFailed = () => ({
  type: GET_GLOBAL_ITEM_FAILED,
})

export const removeGlobalItemRequested = () => ({
  type: REMOVE_GLOBAL_ITEM_REQUESTED,
})
export const removeGlobalItemSucceeded = (uuid) => ({
  type: REMOVE_GLOBAL_ITEM_SUCCEEDED,
  payload: uuid,
})
export const removeGlobalItemFailed = () => ({
  type: REMOVE_GLOBAL_ITEM_FAILED,
})

export const updateToggle = (key, value) => ({
  type: UPDATE_TOGGLE,
  payload: { key, value },
})

export const updateGlobalItemRequested = () => ({
  type: UPDATE_GLOBAL_ITEM_REQUESTED,
})

export const updateGlobalItemSucceeded = (payload) => ({
  type: UPDATE_GLOBAL_ITEM_SUCCEEDED,
  payload,
})

export const updateGlobalItemFailed = () => ({
  type: UPDATE_GLOBAL_ITEM_FAILED,
})

export const createGlobalItem =
  (venueUuid, itemParams, priceLevelParams, itemMappingsParams) =>
  (dispatch) => {
    dispatch(createGlobalItemRequested())

    let priceLevelsWithUuid

    return api
      .createItem(venueUuid, itemParams)
      .then((response) => {
        // price levels
        priceLevelsWithUuid = priceLevelParams.map(
          (priceLevelParams) => {
            return {
              ...priceLevelParams,
              itemUuid: response.data.items[0].uuid,
            }
          }
        )
        dispatch(createGlobalItemSucceeded(response.data.items))

        // item mappings
        const { modifierMinMax, modifierGroups, itemMappings } =
          itemMappingsParams

        if (isEmpty(modifierMinMax)) return

        const { itemMappingsToCreate } =
          calculateItemmMappingsToCreateAndDelete(
            modifierMinMax,
            modifierGroups,
            itemMappings,
            response?.data?.items[0]?.id
          )

        dispatch(
          createItemMapping({
            item_mappings: itemMappingsToCreate,
          })
        )
      })
      .then(() => {
        if (isEmpty(priceLevelParams)) return

        dispatch(createPriceLevelRequested())
        return api.createPriceLevel({
          item_property_overrides: priceLevelsWithUuid,
        })
      })
      .then((response) => {
        if (isEmpty(priceLevelParams)) return
        dispatch(
          createPriceLevelSucceeded(
            response.data.itemPropertyOverrides
          )
        )
      })
      .then(() => dispatch(loadPriceLevels(venueUuid)))
      .catch((error) => {
        dispatch(createGlobalItemFailed())
        return Promise.reject(error)
      })
  }

export const loadGlobalItems = (venueUuid) => (dispatch) => {
  dispatch(getGlobalItemsRequested())

  return api
    .fetchItems(venueUuid)
    .then((response) =>
      dispatch(getGlobalItemSucceeded(response.data.items))
    )
    .catch(() => dispatch(getGlobalItemFailed()))
}

export const getFilteredAndPaginatedItemsRequested = () => ({
  type: GET_FILTERED_AND_PAGINATED_ITEMS_REQUESTED,
})
export const getFilteredAndPaginatedItemsSucceeded = (payload) => ({
  type: GET_FILTERED_AND_PAGINATED_ITEMS_SUCCEEDED,
  payload,
})
export const getFilteredAndPaginatedItemsFailed = () => ({
  type: GET_FILTERED_AND_PAGINATED_ITEMS_FAILED,
})

export const loadFilteredItems = (payload) => (dispatch) => {
  dispatch(getFilteredAndPaginatedItemsRequested())
  return api
    .fetchFilteredAndPaginatedItems(payload)
    .then((res) =>
      dispatch(getFilteredAndPaginatedItemsSucceeded(res))
    )
    .catch(() => dispatch(getFilteredAndPaginatedItemsFailed()))
}

export const updateGlobalItem = (params) => (dispatch) => {
  dispatch(updateGlobalItemRequested())
  return api
    .updateItem(params)
    .then((response) => {
      dispatch(updateGlobalItemSucceeded(response.data.items))
      dispatch(clearItemsIndexes())
    })
    .catch(() => {
      dispatch(updateGlobalItemFailed())
      dispatch(clearItemsIndexes())
    })
}

export const removeGlobalItem = (uuid) => (dispatch) => {
  dispatch(removeGlobalItemRequested())

  return api
    .removeItem(uuid)
    .then(() => dispatch(removeGlobalItemSucceeded(uuid)))
    .catch(() => dispatch(removeGlobalItemFailed()))
}

export const searchGlobalItem = (payload) => ({
  type: SEARCH_GLOBAL_ITEM_SUCCEEDED,
  payload,
})
